export default {
  'ic_notice.png': 'ic_notice.png',
}
